import XAPPService from 'app/Core/services/XAPPService';
export const GET_EMPRESADEPARTAMENTOS = '{EMPRESADEPARTAMENTO APP] GET DEPOSITOS';
export const GET_EMPRESADEPARTAMENTO = '{EMPRESADEPARTAMENTO APP] GET DEPOSITO';
export const GET_TEMPLATE = '{EMPRESADEPARTAMENTO APP] GET TEMPLATE';

export const OPEN_NEW_EMPRESADEPARTAMENTO_DIALOG = '{EMPRESADEPARTAMENTO APP] OPEN NEW DEPOSITO DIALOG';
export const CLOSE_NEW_EMPRESADEPARTAMENTO_DIALOG = '{EMPRESADEPARTAMENTO APP] CLOSE NEW DEPOSITO DIALOG';
export const OPEN_EDIT_EMPRESADEPARTAMENTO_DIALOG = '{EMPRESADEPARTAMENTO APP] OPEN EDIT DEPOSITO DIALOG';
export const CLOSE_EDIT_EMPRESADEPARTAMENTO_DIALOG = '{EMPRESADEPARTAMENTO APP] CLOSE EDIT DEPOSITO DIALOG';

export const EMPRESADEPARTAMENTO_REMOVE = '{EMPRESADEPARTAMENTO APP] DEPOSITO REMOVE';
export const ADD_EMPRESADEPARTAMENTO = '{EMPRESADEPARTAMENTO APP] ADD DEPOSITO';

export const EMPRESADEPARTAMENTO_WARNING = '{EMPRESADEPARTAMENTO APP] DEPOSITO WARNING';
export const EMPRESADEPARTAMENTO_INFO = '{EMPRESADEPARTAMENTO APP] DEPOSITO INFO';
export const EMPRESADEPARTAMENTO_ERROR = '{EMPRESADEPARTAMENTO APP] DEPOSITO ERROR';
export const EMPRESADEPARTAMENTO_SELECIONAR_WARNING = '{EMPRESADEPARTAMENTO APP] DEPOSITO SELECIONAR WARNING';
export const EMPRESADEPARTAMENTO_SELECIONAR_INFO = '{EMPRESADEPARTAMENTO APP] DEPOSITO SELECIONAR INFO';
export const EMPRESADEPARTAMENTO_SELECIONAR_ERROR = '{EMPRESADEPARTAMENTO APP] DEPOSITO SELECIONAR ERROR';


const ListState =
    [
        'idpessoaformulario',
        'idpessoa',
        'idparent',
        'nome',
        'tipo',
        'formulario',
        'statusregistro',
        'statusregistrodescricao',
        'usrins',
        'usrupt',
        'datainsdescricao',
        'datauptdescricao',
        'totalrows',
        'paginas',
    ];

const AddState =
    [
        'idparent',
        'formulario',
        'idpessoa',
        'tipo',
    ];


const UpdateState =
    [
        'formulario'
    ];

export function get(_AIDPessoaFormulario, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Departamento", AActions, "spvwempresadepartamento", ListState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESADEPARTAMENTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESADEPARTAMENTO_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter = null, _APagina = 1) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Departamentos", AActions, "spvwempresadepartamento", ListState, _AAction, AConditionsAND, AConditionsOR, _APagina)

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESADEPARTAMENTOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESADEPARTAMENTO_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESADEPARTAMENTO_DIALOG
    }
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_EMPRESADEPARTAMENTO_DIALOG
    }
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_EMPRESADEPARTAMENTO_DIALOG,
        data
    }
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_EMPRESADEPARTAMENTO_DIALOG
    }
}

export function save(_AValue, _AParams) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, UpdateState);

        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, AddState);
        }


        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESADEPARTAMENTO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams)))
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESADEPARTAMENTO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams)))
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESADEPARTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function remove(_AValue, _AParams) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", "EXCLUIR", "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: EMPRESADEPARTAMENTO_REMOVE
                    })
                ]).then(() => dispatch(list("SELECIONAR", _AParams)))
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESADEPARTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplate() {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction('pessoa', "125")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TEMPLATE,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESADEPARTAMENTO_SELECIONAR_ERROR,
                    payload: error
                });
            });;
    }
}

export function acaoRegistro(_AValue, _AParams, _AAction) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", _AAction, "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: EMPRESADEPARTAMENTO_REMOVE
                    })
                ]).then(() => dispatch(list("SELECIONAR", _AParams)))
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESADEPARTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}
